export default __webpack_public_path__ + "static/media/233.b60849b4.gif";